import { Spacer, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import styles from './confirm.module.scss'

interface Props {
  title: string
  onConfirm: () => void
  onDecline: () => void
  message?: string
  confirmTitle?: string
  declineTitle?: string
  childType?: 'image' | 'form'
  isModalEnabled?: boolean
  wrapperClassName?: string
  containerClassName?: string
  confirmMessageClassName?: string
  actionsClassName?: string
  id?: string
}

const Confirm: React.FC<Props> = props => {
  const {
    title,
    id,
    message,
    confirmTitle,
    declineTitle,
    childType,
    isModalEnabled,
    wrapperClassName,
    containerClassName,
    confirmMessageClassName,
    actionsClassName,
    children,
    onConfirm,
    onDecline,
  } = props
  return (
    <div className={`${styles.confirmWrapper} ${wrapperClassName}`}>
      <div className={`${styles.confirmContainer} ${containerClassName}`}>
        <div>
          <Spacer space="x2" />
          <Text type="body" color="primaryBrand" alignment="center">
            {title}
          </Text>
        </div>
        <div className={`${styles.confirmBody} ${confirmMessageClassName}`}>
          {childType === 'image' && children && (
            <div className={styles.confirmImage}>{children}</div>
          )}
          {childType === 'form' && children && (
            <div className={styles.confirmForm}>{children}</div>
          )}
          <Text type="caption" alignment="center">
            {message}
          </Text>
        </div>
        <div className={`${styles.confirmActions} ${actionsClassName}`}>
          <div className={styles.decline} onClick={() => onDecline()}>
            <Text type="caption" alignment="center" color="primaryHeading">
              {declineTitle || 'Cancel'}
            </Text>
          </div>
          <div
            id={id ?? 'confirm_btn'}
            className={styles.accept}
            onClick={() => onConfirm()}
          >
            <Text type="caption" alignment="center" color="primaryHeading">
              {confirmTitle ?? 'Continue'}
            </Text>
          </div>
        </div>
      </div>
      <div
        className={styles.backdrop}
        onClick={isModalEnabled ? () => onDecline() : () => {}}
      />
    </div>
  )
}

export default Confirm
